import React from 'react';

const styles = {
  body: {
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    lineHeight: 1.7,
    color: '#1e293b',
    background: '#f8fafc',
    padding: 20,
    maxWidth: 720,
    margin: '0 auto',
    minHeight: '100vh',
  },
  h1: { fontSize: 24, marginBottom: 8, color: '#0f172a', fontWeight: 700 },
  h2: { fontSize: 18, margin: '24px 0 8px', color: '#0f172a', fontWeight: 600 },
  p: { fontSize: 15, marginBottom: 8 },
  li: { fontSize: 15, marginBottom: 8 },
  ul: { paddingLeft: 20 },
  date: { fontSize: 13, color: '#64748b', marginBottom: 24 },
  hr: { border: 'none', borderTop: '1px solid #e2e8f0', margin: '24px 0' },
  footer: { fontSize: 13, color: '#94a3b8', textAlign: 'center' },
};

const PrivacyPolicy = () => (
  <div style={styles.body}>
    <h1 style={styles.h1}>Chính sách bảo mật</h1>
    <p style={styles.date}>Cập nhật lần cuối: 19/03/2026</p>

    <p style={styles.p}>
      Ứng dụng <strong>Carnaval Portal</strong> ("Ứng dụng") được phát triển để hỗ trợ quản lý công việc livestream — bao gồm chấm công, lịch phát sóng, thu nhập, hoa hồng và doanh thu. Chúng tôi cam kết bảo vệ quyền riêng tư của bạn.
    </p>

    <h2 style={styles.h2}>1. Dữ liệu chúng tôi thu thập</h2>
    <ul style={styles.ul}>
      <li style={styles.li}><strong>Thông tin tài khoản:</strong> Họ tên, email, số điện thoại, mã nhân viên — dùng để xác thực và quản lý tài khoản.</li>
      <li style={styles.li}><strong>Thông tin ngân hàng:</strong> Tên ngân hàng, số tài khoản, tên chủ tài khoản — dùng để chi trả lương và hoa hồng.</li>
      <li style={styles.li}><strong>Hình ảnh từ Camera:</strong> Ảnh chụp bằng chứng doanh thu được tải lên máy chủ (Cloudinary) để lưu trữ và xác minh.</li>
      <li style={styles.li}><strong>Dữ liệu chấm công:</strong> Thời gian check-in, check-out, lịch sử chấm công.</li>
      <li style={styles.li}><strong>Đăng ký lịch phát sóng:</strong> Lịch livestream đăng ký, ca làm việc.</li>
      <li style={styles.li}><strong>Báo cáo doanh thu:</strong> Doanh số, số đơn hàng, hình ảnh minh chứng.</li>
      <li style={styles.li}><strong>Yêu cầu tạm ứng:</strong> Số tiền và trạng thái yêu cầu tạm ứng lương.</li>
      <li style={styles.li}><strong>Token thông báo đẩy:</strong> Token thiết bị (Expo/Firebase) để gửi thông báo.</li>
    </ul>

    <h2 style={styles.h2}>2. Mục đích sử dụng dữ liệu</h2>
    <ul style={styles.ul}>
      <li style={styles.li}>Cung cấp chức năng ứng dụng: chấm công, đăng ký lịch, báo cáo doanh thu.</li>
      <li style={styles.li}>Quản lý công việc và nhân sự livestream.</li>
      <li style={styles.li}>Tính toán lương, hoa hồng và thu nhập.</li>
      <li style={styles.li}>Gửi thông báo đẩy về lịch làm việc, cập nhật và nhắc nhở.</li>
    </ul>

    <h2 style={styles.h2}>3. Lưu trữ dữ liệu</h2>
    <ul style={styles.ul}>
      <li style={styles.li}>Dữ liệu được lưu trữ trên máy chủ bảo mật sử dụng cơ sở dữ liệu MongoDB.</li>
      <li style={styles.li}>Hình ảnh được lưu trữ trên dịch vụ Cloudinary.</li>
      <li style={styles.li}>Mọi kết nối giữa ứng dụng và máy chủ đều được mã hóa bằng HTTPS.</li>
    </ul>

    <h2 style={styles.h2}>4. Chia sẻ dữ liệu</h2>
    <p style={styles.p}>Dữ liệu của bạn chỉ được chia sẻ với người sử dụng lao động (Carnaval) để phục vụ mục đích quản lý công việc. Chúng tôi <strong>không bán, cho thuê hoặc chia sẻ</strong> dữ liệu cá nhân của bạn cho bất kỳ bên thứ ba nào khác.</p>

    <h2 style={styles.h2}>5. Dịch vụ bên thứ ba</h2>
    <ul style={styles.ul}>
      <li style={styles.li}><strong>Firebase Cloud Messaging:</strong> Gửi thông báo đẩy trên thiết bị Android.</li>
      <li style={styles.li}><strong>Apple Push Notification Service (APNs):</strong> Gửi thông báo đẩy trên thiết bị iOS.</li>
      <li style={styles.li}><strong>Cloudinary:</strong> Lưu trữ hình ảnh minh chứng doanh thu.</li>
    </ul>

    <h2 style={styles.h2}>6. Quyền truy cập</h2>
    <ul style={styles.ul}>
      <li style={styles.li}><strong>Camera:</strong> Chụp ảnh minh chứng doanh thu để đính kèm trong báo cáo.</li>
      <li style={styles.li}><strong>Mạng Internet:</strong> Bắt buộc để kết nối với máy chủ và sử dụng ứng dụng.</li>
      <li style={styles.li}><strong>Thông báo đẩy:</strong> Nhận thông báo về lịch làm việc, cập nhật và nhắc nhở.</li>
    </ul>

    <h2 style={styles.h2}>7. Lưu giữ dữ liệu</h2>
    <p style={styles.p}>Dữ liệu của bạn được lưu giữ trong suốt thời gian tài khoản còn hoạt động. Sau khi tài khoản bị vô hiệu hóa, dữ liệu sẽ được xóa trong vòng 90 ngày.</p>

    <h2 style={styles.h2}>8. Quyền của bạn</h2>
    <ul style={styles.ul}>
      <li style={styles.li}>Truy cập và xem dữ liệu cá nhân của bạn trong ứng dụng.</li>
      <li style={styles.li}>Yêu cầu chỉnh sửa thông tin không chính xác.</li>
      <li style={styles.li}>Yêu cầu xóa tài khoản và dữ liệu cá nhân.</li>
      <li style={styles.li}>Tắt thông báo đẩy trong cài đặt thiết bị.</li>
    </ul>

    <h2 style={styles.h2}>9. Quyền riêng tư trẻ em</h2>
    <p style={styles.p}>Ứng dụng không dành cho người dưới 18 tuổi. Chúng tôi không cố ý thu thập dữ liệu từ trẻ em. Nếu phát hiện dữ liệu của người dưới 18 tuổi đã được thu thập, chúng tôi sẽ xóa ngay lập tức.</p>

    <h2 style={styles.h2}>10. Thay đổi chính sách</h2>
    <p style={styles.p}>Chúng tôi có thể cập nhật chính sách bảo mật này. Mọi thay đổi sẽ được thông báo qua bản cập nhật ứng dụng hoặc thông báo đẩy.</p>

    <hr style={styles.hr} />

    <h2 style={styles.h2}>Điều khoản sử dụng</h2>
    <p style={styles.p}>Bằng việc sử dụng ứng dụng Carnaval Portal, bạn đồng ý với các điều khoản sau:</p>
    <ul style={styles.ul}>
      <li style={styles.li}>Ứng dụng được cung cấp "nguyên trạng" (as is) cho mục đích quản lý công việc nội bộ.</li>
      <li style={styles.li}>Bạn chịu trách nhiệm về độ chính xác của dữ liệu chấm công và báo cáo doanh thu.</li>
      <li style={styles.li}>Bạn không được sử dụng ứng dụng cho mục đích bất hợp pháp.</li>
      <li style={styles.li}>Chúng tôi có quyền tạm ngưng hoặc chấm dứt tài khoản nếu phát hiện vi phạm.</li>
    </ul>

    <h2 style={styles.h2}>Liên hệ</h2>
    <p style={styles.p}>Nếu bạn có câu hỏi về chính sách bảo mật này, vui lòng liên hệ Carnaval qua quản lý trực tiếp hoặc qua ứng dụng.</p>

    <hr style={styles.hr} />
    <p style={styles.footer}>Carnaval Portal &copy; 2025</p>
  </div>
);

export default PrivacyPolicy;
